import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, tap } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private router: Router) {
    
  }

  

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    
    // Check both localStorage and sessionStorage for token (Remember Me feature)
    const token = localStorage.getItem('bearerToken') || sessionStorage.getItem('bearerToken');
    const companyCode = localStorage.getItem('companyCode') || sessionStorage.getItem('companyCode');
     // Call the function to ensure the latest serverUrl

    const baseUrl = environment.APPLICATION_BASEURL;

    if (req.url.lastIndexOf('i18n') > -1) {
      return next.handle(req);
    }

    const url = req.url.lastIndexOf('api') > -1 ? req.url : 'api/' + req.url;

    // Clone the request and append headers based on the availability of token and companyCode
    let newReq = req.clone({ url: `${baseUrl}${url}` });

    // If companyCode exists, set it in the header
    if (companyCode) {
      newReq = newReq.clone({
        headers: newReq.headers.set('CompanyCode', companyCode)
      });
    }

    // If token exists, set it in the header
    if (token) {
      newReq = newReq.clone({
        headers: newReq.headers.set('Authorization', 'Bearer ' + token)
      });
    }
    // Proceed with the new request with the appropriate headers
    return next.handle(newReq).pipe(
      tap(
        () => {},
        (err: any) => {
          if (err instanceof HttpErrorResponse) {
            if (err.status === 401 || err.status === 403) {
              // Clear both localStorage and sessionStorage
              localStorage.removeItem('bearerToken');
              localStorage.removeItem('currentUser');
              sessionStorage.removeItem('bearerToken');
              sessionStorage.removeItem('currentUser');
              // Don't redirect if this is the authentication endpoint
              if (!req.url.includes('/Authentication')) {
                this.router.navigate(['auth/sign-in']);
              }
            } else if (err.status === 409) {
              console.error('Error', err.error);
            }
            else if (err.status === 404) {
              // Don't redirect to 404 page for Face/enrolled-faces API
              // Let the component handle the error locally
              if (!req.url.includes('Face/enrolled-faces')) {
                this.router.navigate(['404']);
              }
            }
            else if (err.status === 400) {
              // Don't redirect to 404 page for Face/enrolled-faces API on 400 errors
              // Let the component handle the error locally
              if (req.url.includes('Face/enrolled-faces')) {
                // Do nothing, let the component handle it
                console.log('Face/enrolled-faces 400 error handled by component');
              }
            }
          }
        }
      )
    );
  }
}